import { render, staticRenderFns } from "./CouncilTaxBandInfo.vue?vue&type=template&id=1b353938&"
import script from "./CouncilTaxBandInfo.vue?vue&type=script&lang=js&"
export * from "./CouncilTaxBandInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports